import SecureLS from 'secure-ls'

export const ls = new SecureLS({
  encodingType: 'aes',
  encryptionSecret: 'pm_hub_nifty',
  isCompression: false,
})